<template>
  <div class="dsio-user-position">
    <input
      :id="'userPositionOn_' + instanceId"
      v-model="userPositionOn"
      class="userPositionOn"
      type="checkbox"
      @click="userPositionClick = true"
    >
    <label
      :for="'userPositionOn_' + instanceId"
      class="lgrid-center-middle-equalHeight"
    >
      <span
        class="label"
        v-html="t.autourDeMoi || 'Autour de moi'"
      />
      <span class="status">
        <i class="dsio-street-view-light" />
      </span>
    </label>

    <modal
      v-if="infoModal"
      @cancel="disableUserPosition"
      @apply="tryUserPosition"
    >
      <h3
        slot="header"
        class="colored"
      >
        <span v-html="t.userInfoModal && t.userInfoModal.title || 'À savoir...'" />
      </h3>
      <div slot="body">
        <div v-html="t.userInfoModal && t.userInfoModal.msg || 'Afin d\'afficher l\'offre la plus proche de vous, nous allons vous demander votre géolocalisation.'" />
      </div>
      <template slot="cancel">
        {{ t.userInfoModal && t.userInfoModal.cancel || 'Annuler' }}
      </template>
      <template slot="apply">
        {{ t.userInfoModal && t.userInfoModal.apply || 'Continuer' }}
      </template>
    </modal>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import Modal from './_popupModal';

// parametres cookies
const cookieOpts = { expires: 7 };

// parametres geolocalisation
const geolocationOpts = {
  enableHighAccuracy: true,
  timeout: 10000,
  maximumAge: 0,
};

const positionErrors = {
  fr: {
    PERMISSION_DENIED: 'Vous devez autoriser la localisation sur ce site pour activer cette fonctionnalité.',
    DEFAULT: 'Désolé, Votre position est inconnue.',
  },
  en: {
    PERMISSION_DENIED: 'You need to enable your location if you want to use this functionality',
    DEFAULT: 'Oops ! Unable to find your location.',
  },
  de: {
    PERMISSION_DENIED: 'Aktivieren sie ihre Geolocation, um diese Funktionalität nutzen zu können',
    DEFAULT: 'Oops ! Wir konnten ihren Standort nicht finden.',
  },
  es: {
    PERMISSION_DENIED: 'Debe habilitar su ubicación si desea utilizar esta funcionalidad',
    DEFAULT: '¡Uy! No se puede encontrar su ubicación.',
  },
  nl: {
    PERMISSION_DENIED: 'U moet uw locatie inschakelen als u deze functionaliteit wilt gebruiken',
    DEFAULT: 'Oeps! Kan uw locatie niet vinden.',
  },
};

export default {
  id: 'dsioUserPos',
  name: 'DsioUserPos',
  components: {
    Modal,
  },
  props: {
    sort: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      userPositionOn: false,
      userPosition: null,
      infoModal: false,
      userPositionClick: false,
    };
  },
  computed: {},
  watch: {
    userPositionOn (isOn) {
      if (isOn) {
        this.userPositionClick ? this.infoModal = true : this.tryUserPosition();
      } else {
        this.disableUserPosition();
      }
      // isOn ? this.tryUserPosition() : this.disableUserPosition();
    },
  },
  created () {
    this.dispatch('addFilter', 'u');
  },
  mounted () {
    this.dispatch('filterReady', 'u');
    this.userPositionOn = Cookies.get('dsioUserPositionOn') === 'true';
  },
  destroyed () {
    // this.dispatch('removeFilter', 'u');
  },
  methods: {
    tryUserPosition () {
      this.infoModal = false;
      navigator.geolocation.getCurrentPosition(this.userPositionSuccess, this.userPositionError, geolocationOpts);
    },
    userPositionError (err) {
      const errors = positionErrors[this.lang];
      switch (err.code) {
        case 1:
          alert(errors.PERMISSION_DENIED);
          break;
        default:
          alert(errors.DEFAULT);
          break;
      }
      this.disableUserPosition();
    },
    userPositionSuccess (user) {
      if (typeof user.coords.latitude !== 'undefined') {
        this.userPosition = [user.coords.latitude, user.coords.longitude];
        Cookies.set('dsioUserPositionOn', true, cookieOpts);
        this.dispatch('updateUserPosition', { userPosition: this.userPosition, sort: this.sort });
      } else {
        this.userPositionError(user);
      }
    },
    disableUserPosition () {
      this.infoModal = false;
      this.userPositionOn = false;
      Cookies.set('dsioUserPositionOn', false, cookieOpts);
      this.dispatch('updateUserPosition', { userPosition: null, sort: null });
    },
  },
};
</script>
